import axios from 'axios'
import config from '@/config'

const instance = axios.create({
  baseURL: config.serverUrlSso,
})

export const getChannelProfile = async ({ ssoToken }) => {
  instance.defaults.headers.common = {}

  const { status, data } = await instance.get('/api/channel/profile', {
    headers: {
      Authorization: ssoToken
    }
  })

  if (status !== 200 || !data.success) {
    throw new Error(data.message)
  }

  return data
}


// WEBPACK FOOTER //
// ./src/api/sso.js